import { parseResponse } from "../../utils/common_lib";
import { baseApi } from "../baseApi";
export const educationApi = baseApi.injectEndpoints({
   tagTypes: ["Immunizations"],
   endpoints: (builder) => ({
      getEducations: builder.query({
         query: (params) => {
            return {
               url: `/intervention/educations.json`,
               method: "GET",
               params: params,
            };
         },
         transformResponse: (response, meta, arg) => {
            return parseResponse(response);
         },
      }),
   }),
});

// Export hooks for usage in functional components
export const { useGetEducationsQuery } = educationApi;
